<template>
    <div class="side-btn">
        <button
            class="base-button px-2 cursorPoint"
            :data-ga-element="`${$route.path}|諮詢顧問`"
            @click="linkTo()">
            <img class="w-100" src="@/assets/social-icon/new-person.svg" />
            <p class="text-sm">諮詢顧問</p>
        </button>
        <button class="base-button" :disabled="!isShowGoTop"
            @click="scrollTop">
             <ChevronUpIcon size="3x" stroke-width="1" />
            <p class="text-top">TOP</p>
        </button>
    </div>
</template>
<script>
import { ChevronUpIcon } from 'vue-feather-icons';
import { shareApi } from '@/utils/ShareApi';
export default {
    components: {
        ChevronUpIcon
    },
    props: {
        articleId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isShowGoTop: false,
        };
    },
    computed: {
        menuList() {
            return this.$store.state.menuList;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.filterGoTopButtonVisibility);
        window.addEventListener('resize', this.filterGoTopButtonVisibility);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.filterGoTopButtonVisibility);
        window.removeEventListener('resize', this.filterGoTopButtonVisibility);
    },
    methods: {
        linkTo() {
            // 這個元件在兩個地方引入，在文章內頁傳文章contentId，其他傳other
            shareApi({
                articleId: this.articleId || 'other',
                shareType: 'RESERVE'
            });
            // 不同分類的文章內頁打不同連結
            const categories = ['健康', '健康飲食'];
            const category = categories[categories.length - 1];
            let item = null;
            this.menuList.find(i => {
                const findChild = i.children.find(j => j.value === category);
                if (findChild) {
                    item = findChild;
                }
                return findChild;
            });
            const link = item.reserveUrl ||
                'https://mservice.fubonlife.com.tw/fubonagent/reserve/redirect/activeToReserve?srcId=KN&productId=CONSULTANT&utm_source=health_insurance_plus&utm_medium=consultant_page&utm_campaign=agent';
            window.open(link);
        },
        scrollTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        filterGoTopButtonVisibility() {
            const windowViewPortHeight = 100;
            const windowPageYOffset = window.scrollY || document.documentElement.scrollTop;
            if (windowPageYOffset > windowViewPortHeight) {
                this.isShowGoTop = true;
            } else {
                this.isShowGoTop = false;
            }
        }
    },
};
</script>
<style scoped>
.base-button {
    border: 0;
    background-color: transparent;
}
.opacity-50 {
opacity: 0.5;
}
.side-btn {
    position: fixed;
    right: 0.5rem;
    bottom: 10vh;
    z-index: 101;
    display: flex;
    flex-direction: column;
    text-align: center;
    background-color: rgba(255,255,255,0.7);
    border-radius: 30px;
    @media (min-width: 1300px) {
        right: calc((100% - 1265px) / 2);
    }
}
.text-sm {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 0.5rem;
    transform: scale(0.9);
}
.text-top {
    font-size: 18px;
    margin-top: -0.75rem;
    text-align: center;
}
.cursorPoint {
    cursor: pointer;
}
</style>
